export const subscription = {
    reward : {
        subscription : 'Subscription',
        whopper_gold:'Whopper VIP',
    },
    profile : {
        subscription_package : 'Browse',
        my_package : 'My Subscription',
    },
    detail : {
        detail : 'Details',
        condition : 'Condition',
        get_plan : 'Get plan',
        expired: 'Expire Date : ',
        buy_subscription : 'You already buy this subscription package',
        buy_now : 'Buy now',
        renewal_package : 'Renewal Package',
        view_package : 'View Rewards',
        cancel_package : 'Confirm to cancel subscription package',
        confirm: 'Confirm',
        condition_confirm_package: 'After confirmation, The package will be cancelled in the next billing cycle',
        cancel_package_success: 'Cancel subscription package success! ThePackage will be cancelled in the next billing cycle',
        cancel_subscription_package: 'Confirm to cancel subscription package',
    },
    subscription_summary : {
        title : 'Review purchase',
        choose_package : 'Choose Package',
        subscription_type : 'Subscription type',
        one_time : 'One time',
        condition_one_time : 'Cannot be canceled until the package has expired',
        recurring : 'Recurring',
        condition_recurring : "Package will be recurring every {0}, if system can't recurring system will be cancel automatically",
        payment_success : 'Your payment has been success !<br>Subscription package already activated.',
        period: {
            day: 'day',
            month: 'month',
            year: 'year',
        }
    },
    buy : {
        subscription_package : 'Subscription Package',
        only_for_member : 'Only for Whopper VIP member',
        condition : 'Conditions',
        buy_now : 'Buy now',
        voucher_not_available : 'Voucher not available',
        saved: 'Saved',
        bath: 'THB!',
        confirm: 'Confirm',
        package: 'Subscription Package',
    },
    redeem : {
        //All text on these page will mapping the same as previous page
    },
    subscription_detail : {
        btn: 'Get coupon',
    }
}